import { useQuery } from "@tanstack/react-query";
import { fetchShowRecommendations } from "../api/fetchShowRecommendations";

export const useRecommendations = (id, sortMode = 'date') => {
  return useQuery({
    queryKey: ["showRecs", id, sortMode],
    queryFn: () => fetchShowRecommendations(id, sortMode),
    enabled: !!id,
  });
};
